/**
 * Универсальный скрипт для B2B форм с выбором страны
 * Работает с формами, которые имеют data-form-type="b2b" или data-form-type="directions-workwith"
 */
(function() {
  'use strict';

  // Инициализация формы
  function initB2BForm(formElement) {
    const formType = formElement.getAttribute('data-form-type') || 'b2b';
    const sectionId = formElement.getAttribute('data-section-id') || '';
    
    // Определяем префиксы классов в зависимости от типа формы
    let classPrefix = 'b2b-';
    if (formType === 'directions-workwith') {
      classPrefix = 'directions-workwith__';
    } else if (formType === 'callback' || formType === 'reserve-item') {
      // Проверяем, используется ли универсальная система попапов
      const isUniversalPopup = formElement.closest('.am-popup');
      classPrefix = isUniversalPopup ? 'am-popup__' : (formType === 'callback' ? 'call-back-' : 'b2b-');
    }
    const formId = formElement.id;
    
    // Получаем элементы формы
    const submitBtn = document.getElementById(`${formType === 'directions-workwith' ? 'directions-workwith-submit' : 'b2b-submit'}-${sectionId}`);
    const buttonText = submitBtn ? submitBtn.querySelector(`.${classPrefix}button-text`) : null;
    const loading = document.getElementById(`${formType === 'directions-workwith' ? 'directions-workwith-loading' : 'b2b-loading'}-${sectionId}`);
    const message = document.getElementById(`${formType === 'directions-workwith' ? 'directions-workwith-message' : 'b2b-message'}-${sectionId}`);
    
    // Country selector elements
    const countrySelector = document.getElementById(`countrySelector-${sectionId}`);
    const countryTrigger = document.getElementById(`countryTrigger-${sectionId}`);
    const countryDropdown = document.getElementById(`countryDropdown-${sectionId}`);
    const countryFlag = document.getElementById(`countryFlag-${sectionId}`);
    const countryCodeDisplay = document.getElementById(`countryCodeDisplay-${sectionId}`);
    const countryCodeInput = document.getElementById(`countryCode-${sectionId}`);
    const countrySearch = document.getElementById(`countrySearch-${sectionId}`);
    const countryList = document.getElementById(`countryList-${sectionId}`);
    let phoneInput;
    if (formType === 'callback' || formType === 'reserve-item') {
      // Для универсальных попапов используем ID с formType (phone-callback или phone-reserve-item)
      const isUniversalPopup = formElement.closest('.am-popup');
      if (isUniversalPopup) {
        // Пробуем найти по ID с formType
        phoneInput = document.getElementById(`phone-${formType}`);
        // Если не нашли, пробуем по sectionId
        if (!phoneInput) {
          phoneInput = document.getElementById(`phone-${sectionId}`);
        }
      } else {
        // Для старого callback попапа используем call-back-phone
        phoneInput = document.getElementById('call-back-phone');
        // Если не нашли, пробуем по sectionId
        if (!phoneInput) {
          phoneInput = document.getElementById(`phone-${sectionId}`);
        }
      }
    } else {
      phoneInput = document.getElementById(`phone-${sectionId}`);
    }
    
    // Если все еще не нашли, пробуем найти любое поле phone внутри формы
    if (!phoneInput) {
      phoneInput = formElement.querySelector('input[type="tel"][name="phone"]');
    }

    let countries = [];
    let selectedCountry = null;
    let cooldownUntil = 0;
    const FORM_COOLDOWN_MS = 120000;
    const SHORT_FIELD_LIMIT = 120;
    const EMAIL_FIELD_LIMIT = 320;

    const FLAG_BASE = 'https://cdn.jsdelivr.net/gh/alexsobolenko/flag-icons@master/flags/1x1/';
    const FLAG_CODES = { AE: 'are', SA: 'sau', QA: 'qat', KW: 'kwt', OM: 'omn', BH: 'bhr' };
    const A2_TO_A3 = { AF: 'afg', AX: 'ala', AL: 'alb', DZ: 'dza', AS: 'asm', AD: 'and', AO: 'ago', AI: 'aia', AQ: 'ata', AG: 'atg', AR: 'arg', AM: 'arm', AW: 'abw', AU: 'aus', AT: 'aut', AZ: 'aze', BS: 'bhs', BH: 'bhr', BD: 'bgd', BB: 'brb', BY: 'blr', BE: 'bel', BZ: 'blz', BJ: 'ben', BM: 'bmu', BT: 'btn', BO: 'bol', BQ: 'bes', BA: 'bih', BW: 'bwa', BV: 'bvt', BR: 'bra', IO: 'iot', BN: 'brn', BG: 'bgr', BF: 'bfa', BI: 'bdi', CV: 'cpv', KH: 'khm', CM: 'cmr', CA: 'can', KY: 'cym', CF: 'caf', TD: 'tcd', CL: 'chl', CN: 'chn', CX: 'cxr', CC: 'cck', CO: 'col', KM: 'com', CG: 'cog', CD: 'cod', CK: 'cok', CR: 'cri', CI: 'civ', HR: 'hrv', CU: 'cub', CW: 'cuw', CY: 'cyp', CZ: 'cze', DK: 'dnk', DJ: 'dji', DM: 'dma', DO: 'dom', EC: 'ecu', EG: 'egy', SV: 'slv', GQ: 'gnq', ER: 'eri', EE: 'est', SZ: 'swz', ET: 'eth', FK: 'flk', FO: 'fro', FJ: 'fji', FI: 'fin', FR: 'fra', GF: 'guf', PF: 'pyf', TF: 'atf', GA: 'gab', GM: 'gmb', GE: 'geo', DE: 'deu', GH: 'gha', GI: 'gib', GR: 'grc', GL: 'grl', GD: 'grd', GP: 'glp', GU: 'gum', GT: 'gtm', GG: 'ggy', GN: 'gin', GW: 'gnb', GY: 'guy', HT: 'hti', HM: 'hmd', VA: 'vat', HN: 'hnd', HK: 'hkg', HU: 'hun', IS: 'isl', IN: 'ind', ID: 'idn', IR: 'irn', IQ: 'irq', IE: 'irl', IM: 'imn', IL: 'isr', IT: 'ita', JM: 'jam', JP: 'jpn', JE: 'jey', JO: 'jor', KZ: 'kaz', KE: 'ken', KI: 'kir', KP: 'prk', KR: 'kor', KW: 'kwt', KG: 'kgz', LA: 'lao', LV: 'lva', LB: 'lbn', LS: 'lso', LR: 'lbr', LY: 'lby', LI: 'lie', LT: 'ltu', LU: 'lux', MO: 'mac', MG: 'mdg', MW: 'mwi', MY: 'mys', MV: 'mdv', ML: 'mli', MT: 'mlt', MH: 'mhl', MQ: 'mtq', MR: 'mrt', MU: 'mus', YT: 'myt', MX: 'mex', FM: 'fsm', MD: 'mda', MC: 'mco', MN: 'mng', ME: 'mne', MS: 'msr', MA: 'mar', MZ: 'moz', MM: 'mmr', NA: 'nam', NR: 'nru', NP: 'npl', NL: 'nld', NC: 'ncl', NZ: 'nzl', NI: 'nic', NE: 'ner', NG: 'nga', NU: 'niu', NF: 'nfk', MK: 'mkd', MP: 'mnp', NO: 'nor', OM: 'omn', PK: 'pak', PW: 'plw', PS: 'pse', PA: 'pan', PG: 'png', PY: 'pry', PE: 'per', PH: 'phl', PN: 'pcn', PL: 'pol', PT: 'prt', PR: 'pri', QA: 'qat', RE: 'reu', RO: 'rou', RU: 'rus', RW: 'rwa', BL: 'blm', SH: 'shn', KN: 'kna', LC: 'lca', MF: 'maf', PM: 'spm', VC: 'vct', WS: 'wsm', SM: 'smr', ST: 'stp', SA: 'sau', SN: 'sen', RS: 'srb', SC: 'syc', SL: 'sle', SG: 'sgp', SX: 'sxm', SK: 'svk', SI: 'svn', SB: 'slb', SO: 'som', ZA: 'zaf', GS: 'sgs', SS: 'ssd', ES: 'esp', LK: 'lka', SD: 'sdn', SR: 'sur', SE: 'swe', CH: 'che', SY: 'syr', TW: 'twn', TJ: 'tjk', TZ: 'tza', TH: 'tha', TL: 'tls', TG: 'tgo', TK: 'tkl', TO: 'ton', TT: 'tto', TN: 'tun', TR: 'tur', TM: 'tkm', TC: 'tca', TV: 'tuv', UG: 'uga', UA: 'ukr', AE: 'are', GB: 'gbr', UM: 'umi', US: 'usa', UY: 'ury', UZ: 'uzb', VU: 'vut', VE: 'ven', VN: 'vnm', VG: 'vgb', VI: 'vir', WF: 'wlf', EH: 'esh', YE: 'yem', ZM: 'zmb', ZW: 'zwe' };

    const getFlagSlug = (code) => {
      const c = (code || '').toUpperCase();
      return FLAG_CODES[c] || (A2_TO_A3[c] || c.toLowerCase());
    };
    const getFlagUrl = (code) => (code ? FLAG_BASE + getFlagSlug(code) + '.svg' : '');

    const renderFlagImg = (code, size = 18) => {
      const url = getFlagUrl(code);
      return url ? `<img src="${url}" alt="" width="${size}" height="${size}" role="presentation">` : '';
    };

    function stripTags(value) {
      return String(value || '').replace(/<[^>]*>/g, '').trim();
    }

    function withLimit(value, limit) {
      return stripTags(value).slice(0, limit);
    }

    function isCooldownActive() {
      return Date.now() < cooldownUntil;
    }

    function parseRetryAfterMs(response, fallbackMs) {
      const retryAfter = Number(response.headers.get('Retry-After'));
      if (Number.isFinite(retryAfter) && retryAfter > 0) {
        return retryAfter * 1000;
      }
      return fallbackMs;
    }

    function setSubmitCooldown(ms) {
      cooldownUntil = Date.now() + ms;
      if (submitBtn) submitBtn.disabled = true;
      if (buttonText) buttonText.style.display = 'block';
      if (loading) loading.style.display = 'none';
      setTimeout(() => {
        if (isCooldownActive()) return;
        resetSubmitButton();
      }, ms);
    }

    function applyFieldLimits() {
      const emailField = formElement.querySelector('input[type="email"], input[name="email"]');
      if (emailField) emailField.maxLength = EMAIL_FIELD_LIMIT;
      formElement.querySelectorAll('input[type="text"], input[type="tel"], input:not([type])').forEach(input => {
        if (input.type === 'email') return;
        input.maxLength = SHORT_FIELD_LIMIT;
      });
    }

    // Загружаем данные стран с сервера
    async function loadCountries() {
      try {
        const response = await fetch('https://office.ampriomilano.com/forms/country');
        if (response.ok) {
          const data = await response.json();
          countries = data.countries || [];
          const defaultCode = data.defaultCountry || 'AE';
          selectedCountry = countries.find(c => c.code === defaultCode) || countries[0];
          
          if (!selectedCountry && countries.length > 0) {
            selectedCountry = countries[0];
          }
        } else {
          // Fallback на дефолтную страну
          selectedCountry = { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', format: '00-000-0000', placeholder: '00-000-0000', flag: '🇦🇪' };
          countries = [selectedCountry];
        }
      } catch (error) {
        // Fallback на дефолтную страну
        selectedCountry = { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', format: '00-000-0000', placeholder: '00-000-0000', flag: '🇦🇪' };
        countries = [selectedCountry];
      }
      
      if (!selectedCountry || countries.length === 0) {
        return false;
      }
      return true;
    }

    // Функция форматирования номера телефона по формату страны
    function formatPhoneNumber(value, format) {
      let cleaned = value.replace(/[^\d]/g, '');
      if (!format || cleaned.length === 0) return cleaned;
      
      let formatted = '';
      let digitIndex = 0;
      for (let i = 0; i < format.length && digitIndex < cleaned.length; i++) {
        if (format[i] === '0') {
          formatted += cleaned[digitIndex];
          digitIndex++;
        } else {
          formatted += format[i];
        }
      }
      return formatted;
    }

    // Заполнение списка стран в dropdown
    function populateCountryList(filter = '') {
      if (!countryList) return;
      
      countryList.innerHTML = '';
      const filtered = countries.filter(country => 
        country.name.toLowerCase().includes(filter.toLowerCase()) ||
        country.dialCode.includes(filter) ||
        country.code.toLowerCase().includes(filter.toLowerCase())
      );

      filtered.forEach(country => {
        const item = document.createElement('div');
        item.className = `${classPrefix}country-item ${selectedCountry.code === country.code ? 'selected' : ''}`;
        item.innerHTML = `
          <span class="${classPrefix}country-item-flag">${renderFlagImg(country.code)}</span>
          <span class="${classPrefix}country-item-name">${country.name}</span>
          <span class="${classPrefix}country-item-code">${country.dialCode}</span>
        `;
        item.addEventListener('click', () => selectCountry(country));
        countryList.appendChild(item);
      });
    }

    // Выбор страны
    function selectCountry(country) {
      if (!country) {
        return;
      }
      
      selectedCountry = country;
      
      if (countryCodeInput) {
        countryCodeInput.value = country.code;
      }
      
      if (countryFlag) {
        const flagHtml = renderFlagImg(country.code);
        countryFlag.innerHTML = flagHtml || '';
      }
      
      if (countryCodeDisplay) {
        countryCodeDisplay.textContent = country.dialCode || '+971';
        // Обновляем padding для поля ввода в зависимости от длины кода (только для B2B форм, не для попапов)
        const isUniversalPopup = formElement.closest('.am-popup');
        if (!isUniversalPopup && phoneInput) {
          const prefixWidth = (country.dialCode || '+971').length * 8 + 4;
          phoneInput.style.paddingLeft = (prefixWidth + 18) + 'px';
        } else if (isUniversalPopup && phoneInput) {
          // Для попапов убираем padding, так как префикс уже отображается отдельно
          phoneInput.style.paddingLeft = '0';
        }
      }
      
      if (phoneInput) {
        phoneInput.placeholder = country.placeholder || country.format || '00-00 00';
      }
      
      closeCountryDropdown();
      
      // Форматируем текущий номер если он есть
      if (phoneInput && phoneInput.value) {
        const cleaned = phoneInput.value.replace(/[^\d]/g, '');
        phoneInput.value = formatPhoneNumber(cleaned, country.format);
      }
    }

    // Открытие/закрытие dropdown
    function toggleCountryDropdown() {
      if (countryDropdown && countryDropdown.style.display === 'none') {
        openCountryDropdown();
      } else {
        closeCountryDropdown();
      }
    }

    function openCountryDropdown() {
      if (!countryDropdown) return;
      countryDropdown.style.display = 'flex';
      populateCountryList();
      setTimeout(() => {
        if (countrySearch) countrySearch.focus();
      }, 50);
    }

    function closeCountryDropdown() {
      if (!countryDropdown) return;
      countryDropdown.style.display = 'none';
      if (countrySearch) countrySearch.value = '';
    }

    // Автоматическое определение страны по IP
    async function detectCountryByIP() {
      if (!countries || countries.length === 0) {
        return;
      }
      
      // Определение страны по IP через freeipapi.com
      try {
        const response = await fetch('https://free.freeipapi.com/api/json/', {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
        
        if (response.ok) {
          const data = await response.json();
          const countryCode = data.countryCode;
          
          if (countryCode) {
            // Ищем страну в списке (регистронезависимо)
            const country = countries.find(c => c.code.toUpperCase() === countryCode.toUpperCase());
            if (country) {
              selectCountry(country);
              return;
            }
          }
        }
      } catch (error) {
        // Ошибка определения страны, оставляем страну по умолчанию
      }
      
      // Все сервисы не сработали, оставляем страну по умолчанию
    }

    // Инициализация country selector
    async function initCountrySelector() {
      // Проверяем наличие всех необходимых элементов
      if (!countrySelector || !phoneInput || !countryFlag || !countryCodeDisplay || !countryCodeInput) {
        return false;
      }

      const loaded = await loadCountries();
      if (!loaded) {
        return false;
      }

      if (countrySelector && phoneInput) {
        // Сначала устанавливаем страну по умолчанию
        if (selectedCountry) {
          selectCountry(selectedCountry);
        }
        
        // Обработчики событий
        if (countryTrigger) {
          countryTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleCountryDropdown();
          });
        }

        if (countrySearch) {
          countrySearch.addEventListener('input', (e) => {
            populateCountryList(e.target.value);
          });
        }

        // Форматирование номера телефона при вводе
        phoneInput.addEventListener('input', (e) => {
          const value = e.target.value;
          const formatted = formatPhoneNumber(value, selectedCountry.format);
          if (formatted !== value) {
            e.target.value = formatted;
          }
        });

        // Закрытие dropdown при клике вне его
        document.addEventListener('click', (e) => {
          if (countrySelector && !countrySelector.contains(e.target)) {
            closeCountryDropdown();
          }
        });

        // Попытка автоматического определения страны (после установки дефолтной)
        if (countries && countries.length > 0) {
          setTimeout(() => {
            detectCountryByIP();
          }, 200);
        }
      }
      
      return true;
    }

    // Обработка отправки формы
    function handleFormSubmit(e) {
      e.preventDefault();
      e.stopPropagation();

      if (isCooldownActive()) {
        showMessage('Too many submissions. Please try again in a minute', 'error');
        return;
      }

      // Show loading state
      if (submitBtn) submitBtn.disabled = true;
      if (buttonText) buttonText.style.display = 'none';
      if (loading) loading.style.display = 'flex';
      if (message) message.style.display = 'none';

      // Get form data
      const formData = new FormData(formElement);
      const phone = formData.get('phone');
      if (!phone) {
        showMessage('Please enter your phone number', 'error');
        resetSubmitButton();
        return;
      }
      
      const phoneCleaned = phone.replace(/[\s\-\(\)]/g, '');
      const email = formData.get('email');
      if (!email) {
        showMessage('Please enter your email', 'error');
        resetSubmitButton();
        return;
      }
      const emailTrimmed = withLimit(email, EMAIL_FIELD_LIMIT).toLowerCase();
      
      // Validate country code
      if (!countryCodeInput || !countryCodeInput.value) {
        showMessage('Please select your country', 'error');
        resetSubmitButton();
        return;
      }
      
      // Validate phone number
      const phoneRegex = /^[0-9]{6,}$/;
      if (!phoneRegex.test(phoneCleaned)) {
        showMessage('Please enter a valid phone number (minimum 6 digits)', 'error');
        resetSubmitButton();
        return;
      }
      
      // Validate email
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(emailTrimmed)) {
        showMessage('Please enter a valid email address', 'error');
        resetSubmitButton();
        return;
      }
      
      const countryCode = countryCodeInput.value;
      const dialCode = selectedCountry ? selectedCountry.dialCode : '';

      const formType = formElement.getAttribute('data-form-type') || 'b2b';
      const data = {
        formType,
        firstName: withLimit(formData.get('firstName') || '', SHORT_FIELD_LIMIT),
        lastName: withLimit(formData.get('lastName') || '', SHORT_FIELD_LIMIT),
        businessName: withLimit(formData.get('businessName') || '', SHORT_FIELD_LIMIT),
        position: withLimit(formData.get('position') || '', SHORT_FIELD_LIMIT),
        businessType: withLimit(formData.get('businessType') || '', SHORT_FIELD_LIMIT),
        seatingCapacity: withLimit(formData.get('seatingCapacity') || '', SHORT_FIELD_LIMIT),
        spaceSize: withLimit(formData.get('spaceSize') || '', SHORT_FIELD_LIMIT),
        roomsCount: withLimit(formData.get('roomsCount') || '', SHORT_FIELD_LIMIT),
        countryCode: withLimit(countryCode, SHORT_FIELD_LIMIT),
        dialCode: withLimit(dialCode, SHORT_FIELD_LIMIT),
        phone: withLimit(phoneCleaned, SHORT_FIELD_LIMIT),
        email: emailTrimmed
      };

      // Send to API
      fetch('https://office.ampriomilano.com/forms/b2b-submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      })
      .then(async response => {
        const contentType = response.headers.get('content-type');
        let result;
        if (response.status === 429) {
          const rateLimitError = new Error('rate_limited');
          rateLimitError.cooldownMs = parseRetryAfterMs(response, FORM_COOLDOWN_MS);
          throw rateLimitError;
        }
        
        if (contentType && contentType.includes('application/json')) {
          try {
            result = await response.json();
          } catch (parseError) {
            const text = await response.text();
            throw new Error(`Failed to parse JSON response: ${text.substring(0, 100)}`);
          }
        } else {
          const text = await response.text();
          throw new Error(`Server returned non-JSON response (${response.status}): ${text.substring(0, 100)}`);
        }
        
        if (!response.ok) {
          throw new Error(result?.error || result?.message || `HTTP error! status: ${response.status}`);
        }
        
        return result;
      })
      .then(result => {
        // Проверяем разные варианты успешного ответа
        if (result.success === true || result.success === 'true' || result.status === 'success' || (result.message && !result.error)) {
          showMessage('Thank you! Your B2B partnership request has been submitted successfully. We will contact you soon.', 'success');
          formElement.reset();
          // Reset country selector
          if (selectedCountry) {
            selectCountry(selectedCountry);
          }
        } else {
          throw new Error(result.error || result.message || 'Failed to submit form');
        }
      })
      .catch(error => {
        if (error.message === 'rate_limited') {
          showMessage('Too many submissions. Please try again in a minute', 'error');
          setSubmitCooldown(error.cooldownMs || FORM_COOLDOWN_MS);
          return;
        }
        showMessage('Sorry, there was an error submitting your request. Please try again.', 'error');
      })
      .finally(() => {
        if (!isCooldownActive()) {
          resetSubmitButton();
        }
      });
    }

    function resetSubmitButton() {
      if (submitBtn) submitBtn.disabled = false;
      if (buttonText) buttonText.style.display = 'block';
      if (loading) loading.style.display = 'none';
    }

    function showMessage(text, type) {
      if (!message) return;
      message.textContent = text;
      message.className = `${classPrefix}message ${type}`;
      message.style.display = 'block';

      // Auto-hide after 5 seconds
      setTimeout(() => {
        message.style.display = 'none';
      }, 5000);
    }

    // Инициализация
    initCountrySelector().then(() => {
      applyFieldLimits();
      // Подключаем обработчик отправки формы только после инициализации
      if (!formElement.dataset.submitHandlerAttached) {
        formElement.dataset.submitHandlerAttached = 'true';
        formElement.addEventListener('submit', handleFormSubmit);
      }
    }).catch((error) => {
      console.warn(`Country selector initialization failed for form ${formId}:`, error);
      applyFieldLimits();
      // Подключаем обработчик даже при ошибке, чтобы форма могла работать
      if (!formElement.dataset.submitHandlerAttached) {
        formElement.dataset.submitHandlerAttached = 'true';
        formElement.addEventListener('submit', handleFormSubmit);
      }
    });
  }

  // Инициализация всех форм при загрузке DOM
  document.addEventListener('DOMContentLoaded', function() {
    // Ищем все формы с data-form-type
    const b2bForms = document.querySelectorAll('[data-form-type="b2b"], [data-form-type="directions-workwith"], [data-form-type="callback"], [data-form-type="reserve-item"]');
    b2bForms.forEach(form => {
      if (!form.dataset.countrySelectorInitialized) {
        form.dataset.countrySelectorInitialized = 'true';
        initB2BForm(form);
      }
    });
  });

  // Экспортируем функцию для ручной инициализации
  window.initB2BForm = initB2BForm;
  
  // Также инициализируем формы, которые могут быть добавлены динамически (например, в попапах)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          const forms = node.querySelectorAll ? node.querySelectorAll('[data-form-type="callback"], [data-form-type="reserve-item"]') : [];
          forms.forEach(form => {
            if (!form.dataset.countrySelectorInitialized) {
              form.dataset.countrySelectorInitialized = 'true';
              initB2BForm(form);
            }
          });
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();